// src/utils/apiConfig.js

export const OPENAI_API_URL = 'https://api.openai.com/v1';

export const getApiHeaders = () => ({
  'Content-Type': 'application/json',
});

export const OPENAI_CONFIG = {
  model: 'gpt-4', // or 'gpt-3.5-turbo' if needed
  temperature: 0.7,
  max_tokens: 500,
};

// Use API Gateway URL for production, localhost for development
export const API_BASE_URL = 'https://8z417mz9yc.execute-api.us-east-1.amazonaws.com/prod/api';
